<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action>
            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h1 class="font-weight-bold text-center w-75">FRAUD WARNINGS</h1>
            </article>

            <article class="input-section form-section" style="padding-right: 56px;">
              <p>
                <strong>FRAUD WARNING: </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.
              </p>
              <p>
                <strong>ARKANSAS, LOUISIANA AND WEST VIRGINIA FRAUD WARNING: </strong>
                Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
              </p>
              <p>
                <strong>COLORADO FRAUD WARNING: </strong>
                It is unlawful to knowingly provide false, incomplete, or misleading facts or information to an insurance company for the purpose of defrauding or attempting to defraud the company.
                Penalties may include imprisonment, fines, denial of insurance benefits, and/or civil damages.
                In Colorado, any insurance company or agent of an insurance company who knowingly provides false, incomplete, or misleading facts or information to a policyholder or claimant for the purpose of defrauding or attempting to defraud the policyholder or claimant with regard to a settlement or award payable from insurance proceeds shall be reported to the Colorado Division of Insurance within the Department of Regulatory Agencies.
              </p>
              <p>
                <strong>D.C. FRAUD WARNING: </strong>
                It is a crime to provide false or misleading information to an insurer for the purpose of defrauding the insurer or any other person. Penalties include imprisonment and/or fines.
                In addition, an insurer may deny insurance benefits if false information materially related to a claim was provided by the applicant.
              </p>
              <p>
                <strong>FLORIDA FRAUD WARNING: </strong>
                Any person who knowingly and with intent to injure, defraud or deceive any insurer, files a statement of claim or an application containing any false, incomplete, or misleading information is guilty of a felony of the third degree.
              </p>
              <p>
                <strong>KANSAS FRAUD WARNING: </strong>
                Any person who, knowingly and with intent to defraud, presents, causes to be presented or prepares with knowledge or belief that it will be presented to or by an insurer, purported insurer, broker or any agent thereof, any written statement as part of, or in support of, an application for the issuance of, or the rating of an insurance policy for personal or commercial insurance, or a claim for payment or other benefit pursuant to an insurance policy for commercial or personal insurance which such person knows to contain materially false information concerning any fact material thereto; or conceals, for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.
              </p>
              <p>
                <strong>KENTUCKY FRAUD WARNING: </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance containing any materially false information or conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime.
              </p>
              <p>
                <strong>MAINE FRAUD WARNING: </strong>
                It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties may include imprisonment, fines or denial of insurance benefits.
              </p>
              <p>
                <strong>MARYLAND FRAUD WARNING: </strong>
                Any person who knowingly and willfully presents a false or fraudulent claim for payment of a loss or benefit or who knowingly and willfully presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
              </p>
              <p>
                <strong>MINNESOTA FRAUD WARNING: </strong>
                A person who submits an application or files a claim with intent to defraud or helps commit a fraud against an insurer is guilty of a crime.
              </p>
              <p>
                <strong>NEW JERSEY FRAUD WARNING: </strong>
                Any person who includes any false or misleading information on an application for an insurance policy is subject to criminal and civil penalties.
              </p>
              <p>
                <strong>NEW MEXICO FRAUD WARNING: </strong>
                Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to civil fines and criminal penalties.
              </p>
              <p>
                <strong>NEW YORK FRAUD WARNING: </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information, or conceals for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent insurance act, which is a crime, and shall also be subject to a civil penalty not to exceed five thousand dollars and the stated value of the claim for each such violation.
              </p>
              <p>
                <strong>OHIO FRAUD WARNING: </strong>
                Any person who, with the intent to defraud or knowing that he is facilitating a fraud against an insurer, submits an application or files a claim containing a false or deceptive statement is guilty of insurance fraud.
              </p>
              <p>
                <strong>OKLAHOMA APPLICANTS: Warning: </strong>
                Any person who knowingly, and with intent to injure, defraud or deceive any insurer, makes any claim for the proceeds of an insurance policy containing any false, incomplete or misleading information is guilty of a felony.
              </p>
              <p>
                <strong>OREGON FRAUD WARNING: </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance containing any materially false information or conceals, for the purpose of misleading, information concerning any fact material to the content of the contract commits a fraudulent insurance act, which may be violating state law and may be subject to prosecution for insurance fraud.
              </p>
              <p>
                <strong>PENNSYLVANIA FRAUD WARNING: </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.
              </p>
              <p>
                <strong>TENNESSEE FRAUD WARNING: </strong>
                It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits.
              </p>
              <p>
                <strong>VIRGINIA AND WASHINGTON FRAUD WARNING: </strong>
                It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits.
              </p>
              <p>
                <strong>VERMONT FRAUD WARNING: </strong>
                Any person who knowingly presents a false statement in an application for insurance may be guilty of a criminal offense and subject to penalties under state law.
              </p>
              <h5 class="font-weight-bold">
                COMPLETION OF THIS FORM DOES NOT BIND COVERAGE. THE APPLICANT ACCEPTS NOTICE THAT ANY POLICY ISSUED WILL APPLY ON A “CLAIMS-MADE” BASIS. THE APPLICANT ACCEPTS NOTICE THAT THEY ARE REQUIRED TO PROVIDE WRITTEN NOTIFICATION TO THE COMPANY OF ANY CHANGES TO THIS APPLICATION THAT MAY HAPPEN BETWEEN THE SIGNATURE DATE BELOW AND ANY PROPOSED EFFECTIVE DATE.
              </h5>
              <p>
                I understand that the final premium will be rounded to the nearest whole dollar. I declare that all statements and particulars herein are true, complete and accurate and that there has been no suppression or misstatements of fact and agree that this application shall be the basis of, and becomes a part of, my Professional Liability coverage.
              </p>
            </article>
            <article class="form-heading form-section review-sign">
              <div class="row pt-4" style="padding-right: 56px;">
                <p class="ml-5">
                  <strong>Consent to Electronic Signature: </strong>
                  I Wish to Sign Electronically. By typing my name below, I hereby sign my application and consent to the use of electronic signature for the purposes of this insurance application. (Please email <a href="mailto:info@orep.org" target="_top">info@orep.org</a> if you do not consent to Electronic Signature.)
                </p>
                <div class="col-md-6">
                  <section class="notice-form">
                    <p class="notice-form-date">Signature:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name to Sign"
                      name="applicantEsignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="groupAppraiser.applicantEsignature"
                    >
                    <span
                      v-show="errors.has('applicantEsignature')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('applicantEsignature') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form">
                    <p class="notice-form-date">Date:</p>
                    <input
                      type="date"
                      class="orep-text-input notice-input text-center"
                      :value="formattedCurrentDate()"
                      disabled
                    >
                  </section>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'group-inspector-3'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('group-appraiser-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('group-appraiser-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('group-appraiser-3')"></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              :disabled="!state.pageFourIsValid"
              :class="{submitDisabled: !state.pageFourIsValid}"
              @click="formSubmit()"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Submitting the application...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS} from "../../utils/constants";

export default {
  name: "group-appraiser-4",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    groupAppraiser() {
      return this.$store.state.groupAppraiser.groupAppraiser;
    },
    state() {
      return this.$store.state.groupAppraiser;
    },
    errorMsg() {
      return this.$store.state.groupAppraiser.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFourIsValid = true;
          return;
        }
        this.state.pageFourIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.groupAppraiser.applicantEsignatureDate).format('YYYY-MM-DD');
    },

    formSubmit() {
      this.loading = true;
      this.state.groupAppraiser.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('groupAppraiser/createGroupAppraiser');
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  components: {}
};
</script>

<style scoped>
</style>

